export interface UsbDeviceId {
  id_vendor: string;
  id_product: string;
  serial: string;
}

export interface UsbDevice {
  id: UsbDeviceId;
  product: string;
  manufacturer: string;
}

export interface NetworkPrinter {
  ip: string;
  port: number;
  mac: string;
  vendor: string;
  update_time: string;
}

export enum PrinterType {
  Ticket = "Ticket",
  BrotherQL = "BrotherQL",
}

export const PrinterTypeOptions = Object.values(PrinterType).map((value) => ({
  label: value,
  value: value,
}));

export type SavedPrinter =
  | {
      id: string;
      type: PrinterType;
      usb: UsbDevice;
      network: null;
    }
  | {
      id: string;
      type: PrinterType;
      usb: null;
      network: NetworkPrinter;
    };
